// @ts-nocheck

import hash from 'sha1';
import { BusinessUser } from '../api/types';

const segmentWriteKey = process.env.REACT_APP_SegmentWriteKey!;
const segmentHashSalt = process.env.REACT_APP_SegmentHashSalt!;

declare global {
  interface Window {
    analytics: SegmentAnalytics.AnalyticsJS;
  }
}

function hashEmailForId(email: string): string {
  return hash(`${email.toLowerCase()}${segmentHashSalt}`).toString();
}

const safelyExecute = (fn: Function, errorMessage = 'Something went wrong') => {
  return (...args) => {
    try {
      return fn.apply(null, args);
    } catch (e) {
      console.error(errorMessage, e);
    }
  };
};

export const init = safelyExecute(() => {
  var analytics = window.analytics;
  analytics.load(segmentWriteKey);
}, 'Something went wrong while initializing analytics');

export const identify = safelyExecute((businessUser: BusinessUser) => {
  const hashedEmail = hashEmailForId(businessUser.email);
  const enhancedData = {
    id: businessUser.id,
    name: businessUser.name,
    email: businessUser.email,
    created: new Date(businessUser.activationDate).toISOString(),
    locale: 'en-US',
    version: 'v2',
  };
  window.analytics.identify(hashedEmail, enhancedData);
}, 'Something went wrong while identifying analytics');

const ZENDESK_TRACK_EVENT = 'ZendeskChannelIntegration';
export const track = safelyExecute((action: string, properties: any) => {
  window.analytics.track(ZENDESK_TRACK_EVENT, {
    action,
    ...properties,
    version: 'v2',
  });
}, `Something went wrong while processing analytics`);
